"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hubspotToolsLogo = _interopRequireDefault(require("bender-url!../../img/hubspot-tools-logo.png"));

var _classnames = _interopRequireDefault(require("classnames"));

var Logo = function Logo(_ref) {
  var onClick = _ref.onClick;
  var classes = (0, _classnames.default)({
    clickable: Boolean(onClick)
  });
  return _react.default.createElement("div", {
    className: "logo"
  }, _react.default.createElement("img", {
    className: "" + classes,
    src: _hubspotToolsLogo.default,
    onClick: onClick
  }));
};

Logo.defaultProps = {
  isClickable: false
};
var _default = Logo;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Logo.js
// module id = 47
// module chunks = 0